import "./compound-interest-calculator.84e41aed.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eZ0we", function(module, exports) {

$parcel$export(module.exports, "PAGE_LANG", () => $ae872a3a7edb7f6b$export$115162aea5a8ed44);
$parcel$export(module.exports, "UI_LOCALE", () => $ae872a3a7edb7f6b$export$7d2f96c91533b722);
$parcel$export(module.exports, "registerTranslations", () => $ae872a3a7edb7f6b$export$595d4929f5276beb);
$parcel$export(module.exports, "t", () => $ae872a3a7edb7f6b$export$625550452a3fa3ec);
$parcel$export(module.exports, "langPath", () => $ae872a3a7edb7f6b$export$1b227894fc2d04d0);
// Helper i18n minimale condiviso dai tool (CV Builder, interesse composto, ...).
// Le chiavi sono le stringhe italiane originali: una voce mancante nel dizionario
// degrada in italiano invece di rompere la UI.
//
// Uso:
//   import { t, PAGE_LANG, UI_LOCALE, langPath, registerTranslations } from './i18n.js';
//   registerTranslations(MY_EN_DICT); // una volta, all'init del modulo
//   t('Annulla')                        -> 'Cancel' su pagine EN, 'Annulla' su pagine IT
//   t('Mancano {n} immagini', { n: 3 }) -> interpolazione {placeholder} in entrambe le lingue
const $ae872a3a7edb7f6b$var$docLang = typeof document !== 'undefined' && document.documentElement?.lang || '';
const $ae872a3a7edb7f6b$var$pathIsEn = typeof location !== 'undefined' && (location.pathname === '/en' || location.pathname.startsWith('/en/'));
const $ae872a3a7edb7f6b$export$115162aea5a8ed44 = $ae872a3a7edb7f6b$var$docLang.toLowerCase().startsWith('en') || !$ae872a3a7edb7f6b$var$docLang && $ae872a3a7edb7f6b$var$pathIsEn ? 'en' : 'it';
const $ae872a3a7edb7f6b$export$7d2f96c91533b722 = $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? 'en-GB' : 'it-IT';
const $ae872a3a7edb7f6b$var$EN_DICT = {};
function $ae872a3a7edb7f6b$export$595d4929f5276beb(map) {
    if (map && typeof map === 'object') Object.assign($ae872a3a7edb7f6b$var$EN_DICT, map);
}
function $ae872a3a7edb7f6b$export$625550452a3fa3ec(str, vars) {
    let out = $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? $ae872a3a7edb7f6b$var$EN_DICT[str] ?? str : str;
    if (vars) out = out.replace(/\{(\w+)\}/g, (match, key)=>key in vars ? String(vars[key]) : match);
    return out;
}
function $ae872a3a7edb7f6b$export$1b227894fc2d04d0(path) {
    return $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? `/en${path}` : path;
}

});

// Entry point del widget recensioni: la logica vive in toolReviewWidget.js, cosi' la
// promo card puo' riusarla senza che questo modulo sia insieme entry e dipendenza.

var $4OFpt = parcelRequire("4OFpt");
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $4OFpt.initToolReviews)();
});


//# sourceMappingURL=compound-interest-calculator.9e032440.js.map
